import type { TableColumns } from '@ohpen/enso-ui';

import type { PermissionRow } from './interfaces';
import { renderRoles } from './utils';

/** Built from the rows, so the filter offers exactly the resources the application declares. */
export const RESOURCE_LIST_NAME = 'permissionResources';

export const permissionColumns: TableColumns<PermissionRow> = [
  {
    title: 'config.columns.section',
    dataIndex: 'resource',
    key: 'resource',
    width: 200,
    options: {
      filter: 'select',
      listName: RESOURCE_LIST_NAME,
      format: { type: 'valueList' },
      sorter: true,
      filterOptions: { allowedModes: ['anyMatches'] },
    },
  },
  {
    title: 'config.columns.action',
    dataIndex: 'action',
    key: 'action',
    width: 140,
    options: { filter: 'search', filterOptions: { allowedModes: ['contains'] } },
  },
  {
    title: 'config.columns.description',
    dataIndex: 'description',
    key: 'description',
    width: 600,
    options: { filter: 'search' },
    render: (description?: string) => description ?? '-',
  },
  {
    title: 'config.columns.heldByRoles',
    dataIndex: 'roles',
    key: 'roles',
    width: 320,
    render: (roles: string[]) => renderRoles(roles),
  },
];
